module.exports = __webpack_public_path__ + "media/images/pic/magazine-44d33ec01dcdea6cf94f0b5ae7888421.png";